import { Component } from '@angular/core';
import { OktaCallbackComponent } from '@okta/okta-angular';

@Component({
  templateUrl: './lnr-okta-callback.page.html',
})
/**
 * Extension of OktaCallbackComponent so that we may act on errors if we want
 */
export class LnrOktaCallbackPage extends OktaCallbackComponent {}
